export const environment = {
  production: false,
  apiUrl: '/api',
  modelo: 1,
  //apiUrl: 'https://localhost:44363'
};
